module.exports = __webpack_public_path__ + "static/media/disco_thumb.d1f3946d.webp";